import type { Ctx } from "../../types";

// All select queries return [{ label: string, value: string }] for use with
// the GGSelect component.

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

export function sortByLabel<T extends { label: string }>(options: T[]): T[] {
  return [...options].sort((a, b) => collator.compare(a.label, b.label));
}

export async function users_by_role({ sb }: Ctx, role: string) {
  const { data } = await sb
    .from("profiles")
    .select("id, full_name, profiles_internal!inner(role)")
    .eq("profiles_internal.role", role)
    .is("deleted_at", null);
  if (!data) return [];

  return sortByLabel(
    data.map((row: any) => ({
      label: row.full_name ?? "",
      value: row.id,
    }))
  );
}
